export const AuthPAGES = {
  baseUrl: '/',
  changePhone: '/change-phone',
  verifyPhone: '/verify-phone',
  verifyEmail: '/verify-email',
  signIn: '/sign-in',
  signUp: '/sign-up',
  registerComplete: '/registration-completed',
  forgotPassword: '/forgot-password',
  pin: '/pin',
  checkPassword: '/check-password',
  userProfile: '/user-profile',
  emailSent: '/email-sent',
  additionalInfo: '/additional-info',
  eula: '/eula',
};

export const ExternalPAGES = {
  mobileDocusignBAA: '/mobile-docusign-baa',
  smartLaunchAuth: '/smart-launch-auth/:id',
  smartLaunch: '/smart-launch/:id',
};

export const FlorencePAGES = {
  subscriptions: '/subscriptions',
  scanPackage: '/scan-package',
  home: '/home',
  results: '/results',
  upload: '/upload',
  savedSheet: '/note/:id',
  editSheet: '/edit-clinic-note',
  editOPNote: '/edit-op-note',
  tFactorAuth: '/t-factor-auth',
};

export const getPageWithID = (page: string, id: number) => {
  return page.replace(':id', id.toString());
};
